import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-two-six-two',
  templateUrl: './two-six-two.component.html',
  styleUrls: ['./two-six-two.component.scss']
})
export class TwoSixTwoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
